module.exports = "//public.getcloudapp.com/packs/media/images/conversation-5585e9c30465cebe4fcb440364a092bb.svg";